import React from "react";
import { FaTrashAlt } from "react-icons/fa";

const AddressCard = ({
  address,
  isEdit,
  showInput,
  editAddress,
  setEditAddress,
  setShowAddressForm,
  onAddressSelect,
  onRemove,
  isRemoving = false,
}) => {
  const { address_id, full_name, mobile_no, street1, street2, city, pincode, type } =
    address;

  const handleAddressSelect = () => {
    onAddressSelect?.(address);
  };

  const handleRemove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onRemove?.(address_id);
  };

  const cardContent = (
    <div className="flex-1 min-w-0 relative">
      <div className="flex items-start justify-between gap-2 mb-1 pr-0">
        <div className="flex flex-wrap items-center gap-2 min-w-0">
          <h3 className="text-base sm:text-lg font-semibold text-gray-900 break-words">{full_name}</h3>
          <span className="text-xs font-medium text-gray-500 bg-gray-100 px-2 py-0.5 rounded shrink-0">{type}</span>
        </div>
        {isEdit && (
          <div className="flex items-center shrink-0">
            <button
              type="button"
              disabled={isRemoving}
              onClick={handleRemove}
              className="p-2 rounded-lg text-red-600 hover:bg-red-50 transition min-h-[44px] min-w-[44px] flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label={isRemoving ? "Removing…" : "Remove address"}
            >
              <FaTrashAlt className="w-4 h-4" />
            </button>
          </div>
        )}
      </div>
      <p className="text-sm text-gray-600 break-words">
        {street1}{street2 ? `, ${street2}` : ""}
      </p>
      <p className="text-sm text-gray-600 break-words">
        {city}, {pincode}
      </p>
      <p className="text-sm text-gray-500 mt-1">
        Mobile: <span className="font-semibold text-gray-700">{mobile_no}</span>
      </p>
    </div>
  );

  const cardClassName =
    "flex items-start gap-3 sm:gap-4 p-4 sm:p-5 rounded-xl bg-white border border-gray-200 shadow-sm hover:shadow-md transition-shadow cursor-pointer";

  if (showInput) {
    return (
      <label className={cardClassName}>
        <input
          type="radio"
          name="address"
          className="mt-1 shrink-0"
          onChange={handleAddressSelect}
        />
        {cardContent}
      </label>
    );
  }

  return <div className={cardClassName}>{cardContent}</div>;
};
export default AddressCard;
